module.exports = __webpack_public_path__ + "img/orangeRadio.2ae282d6.svg";